// extracted by mini-css-extract-plugin
export default {"operacoesEmMassaContainer":"OperacoesEmMassa_operacoesEmMassaContainer__B09bN","modal":"OperacoesEmMassa_modal__Uigfn","modal-content":"OperacoesEmMassa_modal-content__sAoT8"};